module.exports = __webpack_public_path__ + "static/media/Himpunan Mahasiswa Manajemen (Universitas Trilogi).5dbae589.png";